import FormGroup from "legacy/FormGroup"
import { inchesToFeet } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class WaitlistContact extends React.Component {
  constructor(props) {
    super(props)
    this.updateSelect = this.updateSelect.bind(this)
    this.contactBoats = this.contactBoats.bind(this)
    this.boaterInfo = this.boaterInfo.bind(this)
    this.handleChanged = this.handleChanged.bind(this)
    this.handleSelectContactClick = this.handleSelectContactClick.bind(this)
  }

  handleChanged(e) {
    this.props.changed(e)
  }

  handleSelectContactClick() {
    this.props.selectContact(this.props.state.selectedContact)
  }

  updateSelect(e) {
    const boat = _.find(this.props.state.contactBoats, {
      id: Number(e.target.value),
    })
    this.props.selectContactBoat(boat)
  }

  contactBoats() {
    if (this.props.state.contactBoats) {
      const options = []
      this.props.state.contactBoats.forEach((boat) => {
        options.push(
          <option value={boat.id} key={boat.id}>
            {this.props.boaterSide
              ? `${boat.name}, ${inchesToFeet(boat.length_overall)}' ${
                  boat.make || ""
                }`
              : boat.displayName}
          </option>
        )
      })
      options.push(
        <option value={null} key={0}>
          (new boat)
        </option>
      )
      return (
        <FormGroup
          inputType="select"
          label="Boats"
          value={
            this.props.state.selectedContactBoat &&
            this.props.state.selectedContactBoat.id
          }
          onChange={this.updateSelect}
        >
          {options}
        </FormGroup>
      )
    }
  }

  boaterInfo() {
    if (this.props.boaterSide) {
      return (
        <div className="waitlist-contact">
          <h2 className="text-xl">{this.props.state.selectedContact.name}</h2>
          <div className="row">{this.contactBoats()}</div>
        </div>
      )
    } else {
      return (
        <div className="waitlist-contact">
          <div
            className="bs-px-4 float-right cursor-pointer"
            onClick={this.handleSelectContactClick}
          >
            <i
              className="icon icon-cancel-circle text-danger bs-mr-3"
              style={{ fontSize: "2rem" }}
            />
            <span className={{ verticalAlign: "top" }}>Remove Selected</span>
          </div>
          <label>Name:</label> {this.props.state.selectedContact.name}
          <br />
          <label>Email:</label> {this.props.state.selectedContact.email}
          <br />
          <label>Phone:</label> {this.props.state.selectedContact.display_phone}
          <br />
          <div className="row">{this.contactBoats()}</div>
        </div>
      )
    }
  }

  render() {
    this.props.validator.message("name", "true", "required")
    this.props.validator.message("email", "true", "required")
    this.props.validator.message("phone", "true", "required")
    if (this.props.state.selectedContact) {
      return this.boaterInfo()
    } else {
      return (
        <div>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              id="fullName"
              className="form-control"
              type="text"
              name="name"
              onChange={this.handleChanged}
              value={this.props.state.name}
            />
          </div>
          {this.props.validator.message(
            "name",
            this.props.state.name,
            "required"
          )}
          <div className="row nested-row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  className="form-control"
                  type="text"
                  name="email"
                  onChange={this.handleChanged}
                  value={this.props.state.email}
                />
              </div>
              {this.props.validator.message(
                "email",
                this.props.state.email,
                "required|email"
              )}
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  id="phoneNumber"
                  className="form-control"
                  type="text"
                  name="phone"
                  onChange={this.handleChanged}
                  value={this.props.state.phone}
                />
              </div>
              {this.props.validator.message(
                "phone",
                this.props.state.phone,
                "required"
              )}
            </div>
          </div>
          {!this.props.boaterSide ? (
            <div className="text-muted bs-mb-3">
              Add name, email, or phone to search your customers.
            </div>
          ) : null}
        </div>
      )
    }
  }
}

WaitlistContact.propTypes = {
  state: PropTypes.shape({
    selectedContact: PropTypes.object,
    contactBoats: PropTypes.array,
    selectedContactBoat: PropTypes.object,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  boaterSide: PropTypes.bool,
  changed: PropTypes.func.isRequired,
  selectContact: PropTypes.func.isRequired,
  selectContactBoat: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
}

export default WaitlistContact
